module.exports = __webpack_public_path__ + "static/media/TC.803e18a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TC.svg
// module id = 2270
// module chunks = 7